// React
import { FunctionComponent, useEffect, useState } from "react"

// Local constants and services
import vehicleIncidentsTableItems from "../../constants/VehicleIncidentsTableItems"
import VIS from "../../VehicleIncidentsService"

// Interfaces
import { I_SortPayload } from "../../interfaces"

// UI components
import SortCarrot from "src/components/common/SortCarrot/SortCarrot"

/**
 * Renders the table <thead> for the Vehicle Incidents table.
 * Headers are dynamic and sortable based on VIS-managed state.
 */
const VehicleIncidentsTableHeader: FunctionComponent = () => {
  // Track current sort state locally to highlight the correct SortCarrot
  const [sort, setSort] = useState<I_SortPayload>({
    activeKey: VIS.sortBy,
    sortDirection: VIS.sortDirection
  })

  const { activeKey, sortDirection } = sort

  useEffect(() => {
    // Expose setSort to VIS so it can update this header’s local sort state
    Object.assign(VIS, { setSort })
    VIS.assertVehicleIncidentsTableHeaderSettersInitialized()
  }, [])

  return (
    <thead id="vehicle-incidents-table-header">
      <tr>
        {vehicleIncidentsTableItems.map((tblItem, i) => {
          const sortKey = tblItem.customSortKey || tblItem.key

          return (
            <th
              key={`${tblItem.key}-${i}`}
              style={{ width: tblItem.width ?? "unset" }}
            >
              <div className="VehicleIncidentsTableHeaderTH">
                {/* Column title */}
                <div className="VehicleIncidentsTableHeaderTHText">
                  {tblItem.title}
                </div>

                {/* Sort icon, if column is sortable */}
                <div className="VehicleIncidentsTableHeaderTHSort">
                  {tblItem.sortable && (
                    <SortCarrot
                      ascendingCallback={() => VIS.handleSort(sortKey, "asc")}
                      descendingCallback={() => VIS.handleSort(sortKey, "desc")}
                      active={activeKey === sortKey}
                      activeDirection={sortDirection}
                    />
                  )}
                </div>
              </div>
            </th>
          )
        })}
      </tr>
    </thead>
  )
}

export default VehicleIncidentsTableHeader